/* eslint-disable react/prop-types */
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
} from "reactstrap";
import { useState } from "react";
import "./styles.css";
import CardNF from "./CardNF";
import { Link } from "react-router-dom";

function AccordionNF({
  title,
  id,
  dataInicio,
  dataFim,
  buscarNotasFiscais,
  selectedDatePeriod,
  notas,
}) {
  const [open, setOpen] = useState();

  const toggle = (accordionId) => {
    if (open === accordionId) {
      setOpen();
    } else {
      setOpen(accordionId);
    }
  };

  const compararNotas = (a, b) => {
    const statusSort = (b.status === 'emitida') - (a.status === 'emitida');
    return statusSort || new Date(b.updatedAt) - new Date(a.updatedAt);
  };

  return (
    <Accordion open={open} toggle={toggle}>
      <AccordionItem>
        <AccordionHeader targetId={id}>{title}</AccordionHeader>
        <AccordionBody accordionId={id}>
          {notas
          .sort(compararNotas)
          .map((nota, index) => (
            <>
              <CardNF
                key={nota._id}
                isEmiting={false}
                values={nota.values}
                status={nota.status}
                statusPagamento={nota.statusPagamento}
                dataInicio={dataInicio}
                dataFim={dataFim}
                nfId={nota._id}
                buscarNotasFiscais={buscarNotasFiscais}
                selectedDatePeriod={selectedDatePeriod}
              />

              
              {index < notas.length - 1 && (
                  <hr style={{ margin: "10px 0" }} />
              )}

              {nota.status === "cancelado" &&
                <Link to={'/emitir-nota-fiscal'} style={{ textDecoration: 'none'}}>
                  <Button color="danger" block>Resolver pendência</Button>
                </Link>
              }
            </>
          ))}

        </AccordionBody>
      </AccordionItem>
    </Accordion>
  );
}

export default AccordionNF;
